import React from "react";
import PropTypes from "prop-types";
import DocumentScoringSessionHistoryContainer from "features/document/edit/scoringHistory/components/DocumentScoringSessionHistoryContainer";

const FolderScoringSessionHistoryContainer = ({ documentId, siteId, sessionID }) => {
  return <DocumentScoringSessionHistoryContainer documentId={documentId} siteId={siteId} sessionID={sessionID} />;
};

FolderScoringSessionHistoryContainer.propTypes = {
  sessionID: PropTypes.string.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired
};

export default FolderScoringSessionHistoryContainer;
